import { render } from "./Gender.vue.js?vue&type=template&id=71e709c1!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Gender.vue?vue&type=template&id=71e709c1"
import script from "./Gender.vue.js?vue&type=script&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Gender.vue?vue&type=script&lang=js"
export * from "./Gender.vue.js?vue&type=script&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Gender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__